"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "alpago": {
    "cc84ab49": [{
      "hkey": "5a7f4668",
      "slug": "santa-croce-al-lago-sella-fadalto",
      "name": "Santa Croce al Lago-Sella Fadalto",
      "primary": true,
      "skipSearch": false
    }],
    "fadalto": [{
      "hkey": "5a7f4668",
      "slug": "santa-croce-al-lago-sella-fadalto",
      "name": "Santa Croce al Lago-Sella Fadalto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "alpago"
    }],
    "3e86201e": [{
      "hkey": "6404345a",
      "slug": "pieve-d-alpago-torres",
      "name": "Pieve d'Alpago-Torres",
      "primary": true,
      "skipSearch": false
    }],
    "pieve-d-alpago": [{
      "hkey": "6404345a",
      "slug": "pieve-d-alpago-torres",
      "name": "Pieve d'Alpago-Torres",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b8821744": [{
      "hkey": "5a7f4668",
      "slug": "santa-croce-al-lago-sella-fadalto",
      "name": "Santa Croce al Lago-Sella Fadalto",
      "primary": true,
      "skipSearch": false
    }],
    "santa-croce-del-lago": [{
      "hkey": "5a7f4668",
      "slug": "santa-croce-al-lago-sella-fadalto",
      "name": "Santa Croce al Lago-Sella Fadalto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;